import { createFeatureSelector } from '@ngrx/store';

import {
  HideModalReason,
  ModalControlsSaveable,
  ModalControlsSaveableFactory,
} from '®shared/modals';

export const STATE_FEATURE_ARCHIVE_LIST = 'archiveList';

export interface ArchiveListState {
  modalControl: ModalControlsSaveable;
  modalHiddenReason?: HideModalReason;
}

export const ARCHIVE_LIST_INITIAL_STATE: ArchiveListState = {
  modalControl: ModalControlsSaveableFactory.hide(),
};

export function getInitialArchiveListState(): ArchiveListState {
  return ARCHIVE_LIST_INITIAL_STATE;
}

export const selectArchiveListState = createFeatureSelector<ArchiveListState>(
  STATE_FEATURE_ARCHIVE_LIST,
);
